import React, { Component } from 'react';

import CSSTransition from 'react-transition-group/CSSTransition';
import classnames from 'classnames';

import DataPoller from 'components/ui/DataPoller';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import DriverWebAPIUtils from 'utils/CarrierDriverWebAPIUtils';
import { withTranslation } from 'react-i18next';

import DriverBar from './DriverBar';
import SessionStore from '../../../stores/SessionStore';
import DriverStore from '../../../stores/DriverStore';
import AddDriverFormStore from '../../../stores/drivers/AddDriverFormStore';

import AddDriverFormActionCreators from '../../../actions/drivers/AddDriverFormActionCreators';
import DriverActionCreators from '../../../actions/DriverActionCreators';
import UserActionCreators from '../../../actions/UserActionCreators';
import ShipmentsActionCreators from '../../../actions/ShipmentsActionCreators';

import { LAX } from '../../../constants/Markets';
import AddDriverModal from '../user/carrier/add-driver-modal';
import DriverTrackingMap from './DriverTrackingMap';
import { equipmentTypes } from '../../../constants/EquipmentTypes';

import {
  ON_DUTY,
  OFF_DUTY,
} from '../../../constants/DriverStatus';

function fetchAuthorizedDrivers() {
  const carrier = SessionStore.getUser();
  if (carrier) {
    DriverActionCreators.getAuthorizedDriversForCarrier(carrier._id);
  }
}

function closeAssignDriverAlert() {
  DriverActionCreators.resetAssignDriver();
}

const center = LAX.center;

class DriverMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carrier: SessionStore.getUser(),
      market: {
        code: LAX.value,
        center: {
          coords: [...center].reverse(),
        },
      },
      center: [...center],
      filters: {
        near: [...center].reverse(),
        per_page: 500,
        paginate: true,
        distance: 100,
        defaultZoom: 11,
        market: null,
      },
      authorizedDrivers: [],
      filteredDrivers: [],
      markers: [],
      acceptOfferPending: false,
      addDriverModal: {
        formState: {
          error: {},
          show: false,
          isSuccess: false,
        },
      },
      available: null,
      equipmentType: '',
      assignmentPendingOfferId: null,
      offerAssignmentStatus: {
        errorMessage: '',
        successMessage: '',
        offerId: null,
      },
      loading: true,
      currentOpenMarkerId: null,
    };
    this.currentMarker = null;
  }
  componentDidMount() {
    SessionStore.addChangeListener(this.fetchAllDrivers);
    this.fetchAllDrivers();
    DriverStore.addChangeListener(this.handleDriversChange);
    DriverStore.addSelectedShipmentChangeListener(this.handleSelectedShipmentChange);
    AddDriverFormStore.addChangeListener(this.handleAddDriverFormChange);

  }

  componentWillUnmount() {
    DriverStore.removeChangeListener(this.handleDriversChange);
    DriverStore.removeSelectedShipmentChangeListener(this.handleSelectedShipmentChange);
    SessionStore.removeChangeListener(this.fetchAllDrivers);
    AddDriverFormStore.removeChangeListener(this.handleAddDriverFormChange);
  }

  handleAcceptOffer = ({ offerId, offerName }) => {
    this.setState({
      assignmentPendingOfferId: offerId,
      selectedOfferName: offerName,
    });
  }

  handleOfferAssign = ({ offerId, driverId }) => {
    const offerName = this.state.selectedOfferName;
    this.setState({ acceptOfferPending: true });
    DriverActionCreators.acceptOffer({ offerId, driverId, offerName });
  }

  handleCancelAssignment = (offerId) => {
    if (this.state.assignmentPendingOfferId === offerId) {
      this.setState({
        assignmentPendingOfferId: null,
        selectedOfferName: '',
      });
      closeAssignDriverAlert();
    }
  }

  getUpdatedCoordsState(coords) {
    const filters = Object.assign({
      ...this.state.filters,
      near: [...coords],
    });

    return {
      center: [
        coords[1],
        coords[0],
      ],
      filters,
    };
  }

  handleDriversChange = () => {
    const {
      available,
      equipmentType,
    } = this.state;

    const authorizedDrivers = DriverStore.getAuthorizedDrivers() || [];
    const markers = DriverStore.getDriverMarkers();
    const filteredDrivers = filterDrivers(authorizedDrivers, { available, equipmentType });
    const filteredMarkers = filterDrivers(markers, { available, equipmentType });
    const driverLookup = authorizedDrivers.reduce((drivers, driver) => {
      drivers[driver._id] = driver;
      return drivers;
    }, {});
    this.setState({
      authorizedDrivers,
      markers,
      filteredDrivers,
      filteredMarkers,
      driverLookup,
      loading: false,
    });
  }

  getDriverJobs = async (driver) => {
    try {
      if (this.state.selectedDriver !== driver) {
        const { driverLookup } = this.state;
        const driverData = driverLookup[driver];
        if (driverData && driverData.has_active_jobs) {
          const shipments = await ShipmentWebAPIUtils.getDriverJobs(driver);
          this.setState((currentState) => {
            const { markers } = currentState;
            const driverMarker = markers.find(marker => marker.driver._id === driver);
            if (driverMarker) {
              driverMarker.jobs = shipments;
            }
            return { markers, selectedDriver: driver };
          });
        }
      }
    } catch (e) {
      console.log('ERROR: ', e);
    }
  }

  handleSelectedShipmentChange = () => {
    const selectedShipment = DriverStore.getSelectedShipment();
    const activeMarker = DriverStore.getActiveMarker();

    const {
      driver: activeDriver,
    } = activeMarker;

    this.setState({
      selectedShipment,
      activeDriver,
    });
  };

  fetchAllDrivers = () => {
    try {
      const carrier = SessionStore.getUser();
      if (carrier) {
        fetchAuthorizedDrivers();
        const market = carrier.markets[0];

        if (!market) {
          return;
        }

        const {
          center: {
            coords,
          },
        } = market;


        this.setState(Object.assign(
          this.getUpdatedCoordsState(coords),
          {
            market,
          },
        ));
      }
    } catch (e) {
      console.log("Error fetching drivers", e);
      return
    }
  }

  handleDriverToggled = (coords) => {
    if (coords) {
      const updatedCoordsState = this.getUpdatedCoordsState(coords);
      // 2019-09-05 tbrown There is no fetchNearbyDrivers function, removing it for now.
      //this.setState(updatedCoordsState, () => this.fetchNearbyDrivers());
      this.setState(updatedCoordsState);
    }
  }
  handleAddDriverFormChange = () => {
    const formState = AddDriverFormStore.getFormState();
    this.setState({
      addDriverModal: {
        formState,
      },
    });
    if (formState.isSuccess) {
      this.fetchAllDrivers();
      setTimeout(() => {
        AddDriverFormActionCreators.hideForm();
      }, 3000);
    } else if (formState.submittable) {
      const carrier = SessionStore.getUser();
      if (carrier) {
        UserActionCreators.addDriver({
          ...formState.driver,
          carrier: carrier._id,
        });
      }
    }
  }
  handleCloseAddDriverModal = () => {
    AddDriverFormActionCreators.hideForm();
  }
  handleShowAddDriverModal = () => {
    AddDriverFormActionCreators.showForm();
  }
  handleAddDriver = (driver) => {
    AddDriverFormActionCreators.requestValidateNewDriver(driver);
  }

  handleEquipmentTypeChange = (equipmentType) => {
    const {
      available,
      authorizedDrivers,
      markers,
    } = this.state;

    const filteredDrivers = filterDrivers(authorizedDrivers, {
      available,
      equipmentType,
    });

    const filteredMarkers = filterDrivers(markers, {
      available,
      equipmentType,
    });


    this.setState({
      equipmentType,
      filteredDrivers,
      filteredMarkers,
    });
  }

  handleAvailabilityChange = (status) => {
    let available;

    const {
      equipmentType,
      authorizedDrivers,
      markers,
    } = this.state;

    switch (status) {
      case ON_DUTY:
        available = true;
        break;
      case OFF_DUTY:
        available = false;
        break;
      default:
        available = null;
    }

    const filteredDrivers = filterDrivers(
      authorizedDrivers,
      {
        available,
        equipmentType,
      },
    );

    const filteredMarkers = filterDrivers(
      markers,
      {
        available,
        equipmentType,
      },
    );

    this.setState({
      available,
      filteredDrivers,
      filteredMarkers,
    });
  }

  handleOpenShipment = (job) => {
    ShipmentsActionCreators.openTrackingShipment(job);
    ShipmentsActionCreators.closeDriverJobsList();
  }

  handleMapClick = () => {
    ShipmentsActionCreators.closeDriverJobsList();
  }

  handleMarkerClick = (driverId) => {
    ShipmentsActionCreators.driverMarkerClicked(driverId);
    this.getDriverJobs(driverId);
    if (this.state.currentOpenMarkerId !== driverId && this.currentMarker) {
      this.currentMarker.close();
    }
  }

  handleCloseInfoWindow = (driverId) => {
    ShipmentsActionCreators.closeDriverJobsList(driverId);
  }

  setCurrentMarker = (id, marker) => {
    this.setState({ currentOpenMarkerId: id });
    this.currentMarker = marker;
  }

  render() {
    const mapClassName = {
      'driver-tracking-map': true,
    };

    return (
      <div className="driver-map-wrapper">
        <DriverTrackingMap
          className={mapClassName}
          markers={this.state.filteredMarkers}
          selectedShipment={this.state.selectedShipment}
          activeDriver={this.state.activeDriver}
          drivers={this.state.filteredDrivers}
          onOpenShipment={this.handleOpenShipment}
          onMapClick={this.handleMapClick}
          onMarkerClick={this.handleMarkerClick}
          onCloseInfoWindow={this.handleCloseInfoWindow}
          center={this.state.center}
          setCurrentMarker={this.setCurrentMarker}
        />
        <DriverBar
          loading={this.state.loading}
          drivers={this.state.filteredDrivers}
          market={this.state.market}
          equipmentTypes={equipmentTypes}
          equipmentType={this.state.equipmentType}
          onEquipmentTypeChange={this.handleEquipmentTypeChange}
          onDriverToggled={this.handleDriverToggled}
          onAddDriverButtonClick={this.handleShowAddDriverModal}
          available={this.state.available}
          onAvailabilityChange={this.handleAvailabilityChange}
        />
        <AddDriverModal
          key="add-driver-modal"
          onHide={this.handleCloseAddDriverModal}
          onSave={this.handleAddDriver}
          formState={this.state.addDriverModal.formState}
        />
      </div>
    );
  }
}

function filterDrivers(drivers, filters) {
  const {
    available,
    equipmentType,
  } = filters;

  let filteredDrivers = [...drivers];
  if (available !== null) {
    filteredDrivers = filteredDrivers
      .filter(d => d.available === available);
  }

  if (equipmentType) {
    filteredDrivers = filteredDrivers.filter(d => d.equipmentClassLabel.toLowerCase() === equipmentType);
  }

  return filteredDrivers;
}

export default withTranslation()(DriverMap);